<template>
  <div class="input-query-main" :title="placeholder">
    <Dropdown style="width: 50%" :placeholder="placeholder" :items="items" :itemKey.sync="pItemKey" :selectedObject.sync="pSelectedObject"
      :search.sync="pSearch" :isDisabled="isDisabled" :errorMessage.sync="pErrorMessage" ref="dropdown" :isRequired="isRequired" tabindex="-1" @focusIn="dropdownFocus" />
    <button class="query-btn" @click="openTabulator" :disabled="isDisabled" tabindex="-1">
      🔎
      <!-- <div class="dots"></div>
      <div class="dots"></div>
      <div class="dots"></div> -->
      <div v-if="isDisabled" class="query-disabled"></div>
    </button>
    <div class="desc">{{ pSelectedObject == null ? '' : pSelectedObject[descKey] }}</div>

    <div class="table-popup" :style="{ zIndex: showTable ? 999 : -9999999, opacity: showTable ? '1' : '0', width: showTable ? '100%' : 0 }">
      <div class="content">
        <Tabulator :tableID="placeholder.split(' ').join('_')" :tableData="loadedItems" :multiSelect="1" @rowDblClick="rowDblClick" :selectedRow.sync="selectedRow"
        :additionalColumn="selectButtonTable" @cellButtonClick="selectClick" :currentPage.sync="pageNum"
        :currentRowSize.sync="rowSize" :tableTitle="`Find ${placeholder}`" :cancelAllTabIndex="!showTable" />
        <button class="btn" style="color: red" @click="showTable = false" tabindex="-1">Cancel</button>
        <button class="btn" :disabled="selectedRow.length == 0" @click="confirmClicked()" tabindex="-1">Confirm</button>
      </div>
    </div>

    <div v-if="loadingData" class="popup-loading">Please wait . . .</div>
  </div>
</template>

<script>
/* eslint-disable */
import Dropdown from '@/components/Dropdown.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Dropdown, Tabulator
  },
  data: function() {
    return {
      showTable: false,
      loadedItems: [],
      loadingData: false,
      pSelectedObject: null,
      pSearch: '',
      selectedRow: [],
      rowSize: 1,
      pItemKey: null,
      pErrorMessage: ''
    }
  },
  props: {
    tableItems: { type: Array, default: function() { return [] } },
    selectedObject: { type: Object, default: function() { return null } },
    selectButtonTable: { type: Array, default: function() {
      return [
        { value: 'Select', type: 'button', index: 0, frozen: true },
      ]
    }},
    pageNum: { type: Number, default: 1 },

    header: { type: String, default: '' },
    table: { type: String, default: '' },

    // Public properties
    items: { type: Array, default: function() { return [] } }, // The items that will be populated in the dropdown and the tabulator
    placeholder: { type: String, default: 'Items' }, // The placeholder of the dropdown, also the title of the tabulator
    descKey: { type: String, default: '' }, // The key of the items to show as the description at the right side of the query button
    itemKey: { type: String, default: null }, // The key of the items to show in the dropdown
    isDisabled: { type: Boolean, default: false }, // Set as true, and the user will not be able to select or type in the input query
    errorMessage: { type: String, default: '' }, // Set the error message of the inputQuery
    isRequired: { type: Boolean, default: false }, // Set this to true to indicate this input query is required
    search: { type: String, default: '' },
  },
  methods: {
    openTabulator: function() {
      if (this.loadedItems.length == 0) {
        this.loadingData = true;
        setTimeout(() => {
          this.showTable = true;
          this.loadedItems = this.items;

          this.$nextTick(() => {
            this.loadingData = false;
          });
        }, 100);
      } else {
        this.showTable = true;
      }
    },
    rowDblClick: function(data) {
      this.pSelectedObject = data;
      this.$emit('update:selectedObject', this.pSelectedObject);
      this.showTable = false;
    },
    confirmClicked: function() {
      this.pSelectedObject = this.selectedRow[0];
      this.$emit('update:selectedObject', this.pSelectedObject);
      this.showTable = false;
    },
    selectClick: function(btn, data) {
      this.pSelectedObject = data;
      this.$emit('update:selectedObject', this.pSelectedObject);
      this.showTable = false;
    },
    setFocus: function() {
      this.$refs.dropdown.setFocus();

      this.$emit('focusIn', this);
    },
    dropdownFocus: function(e) {
      this.$emit('focusIn', this);
    }
  },
  mounted() {
    if (this.selectedObject) {
      this.pSelectedObject = this.selectedObject;
    }

    if (this.itemKey) {
      this.pItemKey = this.itemKey;
    }

    if (this.errorMessage) {
      this.pErrorMessage = this.errorMessage;
    }
  },
  watch: {
    showTable: function(val) {
      this.pErrorMessage = '';
      if (val) {
        if (this.pSelectedObject) {
          this.selectedRow[0] = this.pSelectedObject;
          this.$emit('update:selectedObject', this.pSelectedObject);
        }
      }
    },
    pageNum: function(val) {
    },
    rowSize: function(val) {
    },
    selectedRow: function(val) {
    },
    pSelectedObject: function(val) {
      this.$emit('update:selectedObject', val);
      this.$emit('selected', val);
    },
    selectedObject: function(val) {
      this.pSelectedObject = val;
    },
    pSearch: function(val) {
      this.$emit('update:search', val);
    },
    pErrorMessage: function(val) {
      this.$emit('update:errorMessage', val);
    },
    errorMessage: function(val) {
      this.pErrorMessage = val;
    },
    itemKey: function(val) {
      this.pItemKey = val;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.input-query-main {
  display: flex;
  width: 100%;
  align-items: center;
  height: 25px;
  padding: 0;
  margin: 2px 0px;
  position: relative;
  // border: 1px solid black;
  
  > .popup-loading {
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }
}

.query-btn {
  background-color: transparent;
  // border: 1px solid rgba(128,128,128,1);
  border: none;
  border-radius: 5px;
  padding: 0 2px;
  width: fit-content;
  margin: 0 2px;
  height: 15px;
  font-weight: bolder;
  display: flex;
  position: relative;
  top: -3px;

  .dots {
    width: 2px;
    height: 2px;
    margin: 0 1px;
    background-color: black;
    border-radius: 100%;
  }

  .query-disabled {
    position: absolute;
    opacity: 0.8;
    background-color: rgba(200,200,200,0.3);
    top: -5px;
    left: -3px;
    height: 24px;
    width: 25px;
  }
}

.desc {
  width: 100%;
  margin-left: 5px;
  font-size: 12px;
}

.table-popup {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.3);
  padding: 10px;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 115;
  padding-top: calc(#{$top-nav-height} + 10px);
}

.table-popup .content {
  position: relative;
  background-color: white;
  width: 90%;
  padding: 10px;
  border-radius: 5px;
  height: 70%;
}

.btn {
  position: relative;
  top: 47px;
  left: calc(100% - 150px);
  background-color: white;
  border-radius: 0;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  margin: 0 3px;
}
</style>